import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";

// Public Pages
import HomePage from "./pages/HomePage";
import SearchResultsPage from "./pages/SearchResultsPage";
import SeatSelectionPage from "./pages/SeatSelectionPage";
import BookingFormPage from "./pages/BookingFormPage";
import PaymentPage from "./pages/PaymentPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelledPage from "./pages/PaymentCancelledPage";
import TicketPage from "./pages/TicketPage";
import TrackingPage from "./pages/TrackingPage";
import PassengerProfilePage from "./pages/PassengerProfilePage";
import LuggageTicketPage from "./pages/LuggageTicketPage";

// Auth Pages
import LoginPage from "./pages/LoginPage";

// Dashboard Pages
import DashboardPage from "./pages/dashboard/DashboardPage";
import ManifestPage from "./pages/dashboard/ManifestPage";
import ScannerPage from "./pages/dashboard/ScannerPage";
import SearchPassengersPage from "./pages/dashboard/SearchPassengersPage";
import DriverDashboard from "./pages/dashboard/DriverDashboard";
import LuggagePage from "./pages/dashboard/LuggagePage";
import LuggageDashboardPage from "./pages/dashboard/LuggageDashboardPage";
import LuggageHistoryPage from "./pages/dashboard/LuggageHistoryPage";
import LuggageManifestPage from "./pages/dashboard/LuggageManifestPage";
import ExpensesPage from "./pages/dashboard/ExpensesPage";
import ReportsPage from "./pages/dashboard/ReportsPage";
import LoyaltyPage from "./pages/dashboard/LoyaltyPage";

// Admin Pages
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminTrips from "./pages/admin/AdminTrips";
import AdminBuses from "./pages/admin/AdminBuses";
import AdminRoutes from "./pages/admin/AdminRoutes";
import AdminStations from "./pages/admin/AdminStations";
import AdminUsers from "./pages/admin/AdminUsers";
import ActivityLogsPage from "./pages/admin/ActivityLogsPage";
import PrintHistoryPage from "./pages/admin/PrintHistoryPage";
import GPSTrackingPage from "./pages/admin/GPSTrackingPage";
import LiveFleetMap from "./pages/admin/LiveFleetMap";
import RevenueDashboard from "./pages/admin/RevenueDashboard";
import IntegrationsPage from "./pages/admin/IntegrationsPage";

// Enterprise enhancements (Phase 1 + 2)
import AIChatbot from "./components/AIChatbot";

import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/search" element={<SearchResultsPage />} />
          <Route path="/select-seats/:tripId" element={<SeatSelectionPage />} />
          <Route path="/booking/:tripId" element={<BookingFormPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/success/:bookingRef" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancelled" element={<PaymentCancelledPage />} />
          <Route path="/payment/:bookingId" element={<PaymentPage />} />
          <Route path="/ticket/:bookingRef" element={<TicketPage />} />
          <Route path="/qr/ticket/:bookingRef" element={<TicketPage />} />
          <Route path="/profile" element={<PassengerProfilePage />} />
          <Route path="/luggage-ticket/:luggageRef" element={<LuggageTicketPage />} />
          <Route path="/qr/luggage/:luggageRef" element={<LuggageTicketPage />} />
          <Route path="/track" element={<TrackingPage />} />
          
          {/* Auth Routes */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Station Dashboard Routes */}
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/dashboard/manifest/:tripId" element={<ManifestPage />} />
          <Route path="/dashboard/scanner" element={<ScannerPage />} />
          <Route path="/dashboard/search" element={<SearchPassengersPage />} />
          <Route path="/dashboard/driver" element={<DriverDashboard />} />
          <Route path="/dashboard/luggage" element={<LuggagePage />} />
          <Route path="/dashboard/luggage-dashboard" element={<LuggageDashboardPage />} />
          <Route path="/dashboard/luggage-history" element={<LuggageHistoryPage />} />
          <Route path="/dashboard/luggage-manifest" element={<LuggageManifestPage />} />
          <Route path="/dashboard/luggage-manifest/:tripId" element={<LuggageManifestPage />} />
          <Route path="/dashboard/expenses" element={<ExpensesPage />} />
          <Route path="/dashboard/reports" element={<ReportsPage />} />
          <Route path="/dashboard/loyalty" element={<LoyaltyPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/trips" element={<AdminTrips />} />
          <Route path="/admin/buses" element={<AdminBuses />} />
          <Route path="/admin/routes" element={<AdminRoutes />} />
          <Route path="/admin/stations" element={<AdminStations />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/activity-logs" element={<ActivityLogsPage />} />
          <Route path="/admin/print-history" element={<PrintHistoryPage />} />
          <Route path="/admin/gps-tracking" element={<GPSTrackingPage />} />
          <Route path="/admin/fleet-live" element={<LiveFleetMap />} />
          <Route path="/admin/revenue" element={<RevenueDashboard />} />
      <Route path="/admin/integrations" element={<IntegrationsPage />} />
        </Routes>
        <AIChatbot />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
